import { mapGetters } from 'vuex';
import { dynamicHead } from '@/mixins/dynamic-head';

export default {
  name: 'PageNotFound',
  mixins: [dynamicHead],
  created() {
    this.metaParams.prerender = {
      content: '404'
    };
    this.setMeta();
  },
  computed: {
    ...mapGetters(['languages', 'currentLanguage'])
  }
};
